import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M6.077 13.786H3.522a1.311 1.311 0 0 1-1.31-1.309v-1.449A1.3 1.3 0 0 1 2.6 10.1l3.037-3.038a4.109 4.109 0 1 1 8.151-.745 4.107 4.107 0 0 1-5.211 3.958v1.009a.75.75 0 0 1-.75.75h-1v1a.75.75 0 0 1-.75.752Zm-2.365-1.5h1.615v-1a.75.75 0 0 1 .75-.75h1V9.223a.749.749 0 0 1 1-.707l.877.31a2.579 2.579 0 0 0 1.172.064 2.64 2.64 0 0 0 1.108-.475 2.607 2.607 0 0 0 .148-4.068 2.633 2.633 0 0 0-.976-.53 2.608 2.608 0 0 0-2.15.319 2.608 2.608 0 0 0-1.074 2.942.75.75 0 0 1-.182.747l-3.288 3.283Z';
const draw24px =
  'M18.883,5.116a6.356,6.356,0,0,0-10.7,5.89l-5.24,5.17a1.772,1.772,0,0,0-.52,1.25v2.4a1.752,1.752,0,0,0,1.75,1.75h3.75a.749.749,0,0,0,.75-.75v-1.3h1.29a.755.755,0,0,0,.75-.75v-1.29H12a.755.755,0,0,0,.75-.75v-.97a6.451,6.451,0,0,0,3.06.05,6.351,6.351,0,0,0,3.07-10.7Zm.24,5.62a4.825,4.825,0,0,1-3.63,3.62,4.913,4.913,0,0,1-3.17-.34.738.738,0,0,0-.72.04.755.755,0,0,0-.35.64v1.29H9.963a.743.743,0,0,0-.75.75v1.29H7.923a.743.743,0,0,0-.75.75v1.3h-3a.248.248,0,0,1-.25-.25v-2.4a.287.287,0,0,1,.07-.18l5.55-5.47a.751.751,0,0,0,.19-.75,5.023,5.023,0,0,1-.1-2.44,4.846,4.846,0,0,1,3.64-3.71,5.147,5.147,0,0,1,1.1-.12,4.865,4.865,0,0,1,4.75,5.98Zm-2.36-2a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,16.763,8.736Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const KeyIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'key'),
) as IconWithRender;

KeyIcon.displayName = 'KeyIcon';
KeyIcon.propTypes = Icon.propTypes;
KeyIcon.renderIcon = (props) => <KeyIcon {...props} />;
export default KeyIcon;
